/* eslint-disable max-len */
import { memo } from 'react';
import { Icon } from 'react-bootstrap-icons';

export const WebPageIcon: Icon = memo(({
  color = 'currentColor',
  size = '1em',
  title = null,
  ...rest
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 820.468 1046.32"
      width={ size }
      height={ size }
      fill={ color }
      { ...rest }
    >
      { title ? <title>{ title }</title> : null }

      <g>
        <rect height="1046.32" opacity="0" width="820.468" x="0" y="0"/>
        <path d="M170.728 446.331C154.63 446.331 144.875 437.062 144.875 421.453C144.875 418.039 145.85 411.209 148.289 405.356L219.995 206.824C227.312 186.337 239.019 176.581 258.53 176.581C279.505 176.581 291.7 186.337 299.017 206.824L370.723 405.356C372.674 411.697 373.649 418.039 373.649 421.453C373.649 437.062 364.381 446.331 347.796 446.331C335.114 446.331 326.821 439.014 322.431 422.917L304.871 374.625L213.166 374.625L196.581 422.917C192.19 439.501 183.898 446.331 170.728 446.331ZM224.385 334.138L294.139 334.138L260.481 231.702L257.555 231.702ZM478.037 260.969C459.989 260.969 447.306 247.799 447.306 230.726C447.306 214.141 459.989 200.971 478.037 200.971L646.326 200.971C663.398 200.971 676.569 214.141 676.569 230.726C676.569 247.799 663.398 260.969 646.326 260.969ZM478.037 431.209C459.989 431.209 447.306 418.039 447.306 400.966C447.306 384.381 459.989 371.21 478.037 371.21L646.326 371.21C663.398 371.21 676.569 384.381 676.569 400.966C676.569 418.039 663.398 431.209 646.326 431.209ZM142.436 854.125L142.436 616.083C142.436 573.157 166.825 551.206 208.288 551.206L612.668 551.206C655.594 551.206 678.032 573.157 678.032 616.083L678.032 849.248L624.375 849.248L526.816 737.055C518.036 726.812 505.354 722.909 493.159 722.909C481.939 722.909 470.232 727.299 459.013 737.055L359.016 825.833L319.017 789.249C309.749 780.957 299.017 777.054 289.261 777.054C279.505 777.054 269.75 780.469 260.481 789.249L196.093 854.125ZM322.919 737.055C351.699 737.055 375.601 712.666 375.601 684.374C375.601 655.106 351.699 632.667 322.919 631.692C293.651 630.716 270.237 655.106 270.237 684.374C270.237 712.666 293.651 737.055 322.919 737.055ZM0 893.149C0 995.098 50.2427 1045.83 151.216 1045.83L669.252 1045.83C770.225 1045.83 820.468 995.098 820.468 893.149L820.468 153.167C820.468 51.7061 770.225 0 669.252 0L151.216 0C50.2427 0 0 51.7061 0 153.167Z" fill={ color }/>
      </g>
    </svg>
  );
});
